import { Box, Typography } from '@mui/material'
import { type Plate } from 'metalworks-domain'

import { GenericDimensionInput } from '@salsita-ai/platform-project-sdk/react'

import { SummaryDetailRow } from './price-info'

interface QuantityInputProps {
  id: Plate['id']
}

export const QuantityInput = (props: QuantityInputProps) => {
  const { id } = props

  return (
    <SummaryDetailRow>
      <Typography variant="body2" color="secondary">
        Plate Quantity
      </Typography>
      <Box sx={{ width: 120 }}>
        <GenericDimensionInput entityId={id} instanceName="quantity" size="small" />
      </Box>
    </SummaryDetailRow>
  )
}
